import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  fetchMaintenanceTypes,
  createMaintenanceType,
  updateMaintenanceType,
  deleteMaintenanceType,
} from "../../api/maintenance/maintenanceTypesApi";

export const useMaintenanceTypes = () => {
  const queryClient = useQueryClient();

  // Consulta optimizada para obtener tipos de mantenimiento
  const {
    data: maintenanceTypes = [],
    error,
    isLoading,
  } = useQuery({
    queryKey: ["maintenanceTypes"],
    queryFn: fetchMaintenanceTypes,
    staleTime: 1000 * 60 * 5, // 5 minutos
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });

  // Reutilizable para invalidar caché
  const invalidateCache = () => {
    queryClient.invalidateQueries({ queryKey: ["maintenanceTypes"] });
  };

  const createMutation = useMutation({
    mutationFn: createMaintenanceType,
    onSuccess: invalidateCache,
  });

  const updateMutation = useMutation({
    mutationFn: ({ id, data }) => updateMaintenanceType(id, data),
    onSuccess: invalidateCache,
  });

  const deleteMutation = useMutation({
    mutationFn: deleteMaintenanceType,
    onSuccess: invalidateCache,
  });

  return {
    maintenanceTypes,
    isLoading,
    error,
    createMutation,
    updateMutation,
    deleteMutation,
  };
};
